import React, { Component } from 'react';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import BekendeCursusNew from '../../../../Modules/Leden/Lid/Toevoegen/BekendeCursusNew'
import Api from '../../../../../Global/Modules/Api';

import RefferalSearch from '../../../../Modules/Leden/Lid/Toevoegen/RefferalSearch'
import RegularSearch from '../../../../Modules/Leden/Lid/Toevoegen/RegularSearch'
import AdminMenu from '../../../../Modules/AdminMenu';
import LedenMenu from '../../../../Modules/Leden/LedenMenu';
import LidAlgemeneInfo from '../../../../Modules/Leden/Lid/LidGeneralData';

const FETCH_URL = "api/educations/courseadmin"

class AdminMemberCursusAdd extends Component {
	constructor(props) {
		super(props)
		this.onUpdate = this.onUpdate.bind(this)
		this.onFileUpdate = this.onFileUpdate.bind(this)
		this.handleSubmit = this.handleSubmit.bind(this)
		this.state = {
			institution: null,
			course: null,
			date: '',
			points: '',
			diploma: false,
			errors: {}
		}
	}

	onUpdate = (name, value) => {
		this.setState({
			[name]: value
		})
	}

	onFileUpdate = file => {
		this.fileInput = file
	}

	// Function that will be executed when the submit button is pressed
	handleSubmit(event) {
		event.preventDefault()
		Api.print(`Institution: ${this.state.institution}; course: ${this.state.course}; date: ${this.state.date}; points: ${this.state.points}`)

		var formData = new FormData()
		formData.append('courseId', this.state.course)
		formData.append('yearEnd', this.state.date)
		formData.append('MemberId', this.props.match.params.id)
		const file = this.fileInput.files[0]
		formData.append('file', file === undefined ? null : file)

		Api.print(
			`Institution: ${this.state.institution}; 
			course: ${this.state.course}; 
			date: ${this.state.date}; 
			points: ${this.state.points},
			file: ${this.fileInput.files[0]}`
		)

		Api.PostApiWithFile(FETCH_URL, formData, this.props.history)
			.then(response => {
				if (response !== undefined)
					Api.print(response)

				else {
					alert('Education saved')
					window.location.href = '/admin/leden/lid/kennis/' + this.props.match.params.id
				}
			})
	}
	render() {
		return (
			<div className="route">
				<AdminMenu />
				<h1 className="pageTitle">
					Een cursus toevoegen
        		</h1>
				<LedenMenu id={this.props.match.params.id} />
				<h4><strong>Cursus</strong></h4>
				<LidAlgemeneInfo id={this.props.match.params.id} />
				<div className="grey-bg">
					<Form horizontal onSubmit={this.handleSubmit}>
						<Row>
							<Col md={6}>
								<h4>Zoek op referentie nummer</h4>
								<hr />
								<RefferalSearch onUpdate={this.onUpdate} />
							</Col>
							<Col md={6}>
								<h4>Regulier zoeken</h4>
								<hr />
								<RegularSearch type="C" onUpdate={this.onUpdate} />
							</Col>
						</Row>
						<hr />
						<Row>
							<Col mdPush={2} md={8}>
								<BekendeCursusNew
									onUpdate={this.onUpdate}
									onFileUpdate={this.onFileUpdate}
									points={this.state.points}
									diploma={this.state.course ? this.state.diploma : null} />
							</Col>
						</Row>
						<Row>
							<Col sm={2}>
								<Link to={'/admin/leden/lid/kennis/' + this.props.match.params.id} className="btn btn-default">Terug</Link>
							</Col>
							<Col smOffset={8} sm={2}>
								<Button type="submit">Toevoegen</Button>
								{Api.showError(this.state.errors, "generalError")} <br /><br />
							</Col>
						</Row>
						<Row>
							<Col sm={12}>
								<p><i>* Na controle van de invoer wordt het aantal punten definitief vastgesteld. Dit kan verschillen met het puntenaantal dat automatisch gegenereerd wordt. </i></p>
								<p className="text-right"><Link to={"/adminmember/kennis/onbekende-cursus/toevoegen/" + this.props.match.params.id}>Staat jouw cursus er niet bij? voeg er een toe!</Link></p>

							</Col>
						</Row>
					</Form>
				</div>
			</div>
		);
	}
}

export default AdminMemberCursusAdd;



// WEBPACK FOOTER //
// ./src/components/Admin/Pages/Leden/Lid/Toevoegen/Cursus.js